import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent';
import { GridChildren } from '../../shared/utils/LingtBlueContainer';
import { SkeletonCom } from '../../shared/utils/SkeletonCom';
import { Box, Grid2, Typography } from '@mui/material';
import SchoolMyCourseCard from '../../shared/components/school/SchoolMyCourseCard';
import { Grid_Gap } from '../../shared/constants';
import { formatDateToDDMMYYYY } from '../../shared/formatter';
import { useGetTeacherCoursesList } from '../../assets/nodeApi/getApi/getTeacherApi';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/useAuthStore';

const ProTeacherMyCourses = () => {
    const { user } = useAuthStore()
    const { data: CourseList, isLoading: isLoadingCourseList } = useGetTeacherCoursesList();

    const navigate = useNavigate()
    return (
        <NormalContainerWithHeader headerText={"My Courses"} >
            <Grid2 container spacing={Grid_Gap}>
                {isLoadingCourseList ? (
                    [...Array(9)].map((_, index) => (
                        <GridChildren index={index} key={index}>
                            <SkeletonCom />
                        </GridChildren>
                    ))
                ) : CourseList?.data?.length === 0 ? (
                    <Box textAlign="center" width="100%">
                        <Typography >Course not found.</Typography>
                    </Box>
                ) : (
                    CourseList?.data?.map((item, index) => (
                        <GridChildren index={index} key={index}>
                            <SchoolMyCourseCard item={item}
                                details={
                                    [
                                        user?.role !== "pro_teacher" && {
                                            label: "Price",
                                            value: `₹ ${item?.price}`,
                                        },
                                        { label: "From", value: formatDateToDDMMYYYY(item?.start_date) },
                                        { label: "to", value: formatDateToDDMMYYYY(item?.end_date) },
                                    ].filter(Boolean)
                                }
                                title={item?.title}
                                buttonAction={() => {
                                    navigate(`/proteacher/lmsdetail/${item?.id}`)
                                }}
                            />
                        </GridChildren>
                    ))
                )}
            </Grid2>
        </NormalContainerWithHeader>
    )
}

export default ProTeacherMyCourses

